/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Delivery_ScheduledInputs */

const tr_geliver_substatus_delivery_scheduled = /** @type {(inputs: Geliver_Substatus_Delivery_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslimat Planlandı`)
};

const en_geliver_substatus_delivery_scheduled = /** @type {(inputs: Geliver_Substatus_Delivery_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Scheduled`)
};

const de_geliver_substatus_delivery_scheduled = /** @type {(inputs: Geliver_Substatus_Delivery_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferung geplant`)
};

const ru_geliver_substatus_delivery_scheduled = /** @type {(inputs: Geliver_Substatus_Delivery_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка запланирована`)
};

/**
* | output |
* | --- |
* | "Delivery Scheduled" |
*
* @param {Geliver_Substatus_Delivery_ScheduledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_delivery_scheduled = /** @type {((inputs?: Geliver_Substatus_Delivery_ScheduledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Delivery_ScheduledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_delivery_scheduled(inputs)
	if (locale === "de") return de_geliver_substatus_delivery_scheduled(inputs)
	if (locale === "ru") return ru_geliver_substatus_delivery_scheduled(inputs)
	return tr_geliver_substatus_delivery_scheduled(inputs)
});